/**
 * Sets the current order in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {Object} order - The order object to set as the current order.
 */
const setCurrentOrder = (state, order) => {
  state.currentOrder = order;
};
/**
 * Sets the order list in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {Array} orderList - The new order list to be set.
 */
const setOrderList = (state, orderList) => {
  state.orderList = orderList;
};
export default {
  setCurrentOrder,
  setOrderList
};
